import { Ability } from '@casl/ability';

import { createAppAbility, createAppRulesFactory } from '../core';
import { ACTION_ALIASES, ActionType, SubjectType } from './data';

export type AppAbility = Ability<[ActionType, SubjectType]>;

export const appAbility = createAppAbility<AppAbility>(ACTION_ALIASES);
export const createAppRules = createAppRulesFactory<AppAbility>();
